<template>
	<div class="introduce">
		<div class="relative box1 box">
			<img :src="windowWidth > 820?'https://qiniuimg.wurun.net/zjwr_banner.png':'https://qiniuimg.wurun.net/news/zjwr1.jpg'" alt="" mode="widthFix">
			<div class="text">
				<div class="fs45 fw mt30">走进五润</div>
				<div class="fs22 mt30">一个包子，一家店，一个生态产业链</div>
				<div class="cor-8f fs10 let-spc6">Entering Weroom Group</div>
				<!-- <p class="ico"></p> -->
			</div>
		</div>
		<div class="tab fs16 flex just-center" v-if="windowWidth > 820">
			<div v-for="(d,i) in tab" :class="i == tabIdx?'active':''" @click="goToDem(i,d)">{{d.name}}</div>
		</div>
		<div class="box2Cont box">
			<div id="box2" class=" box2  w1200 flex align-items just-between">
				<div class="fl" :class="init?'init':''">
					<img src="https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/w.png" mode="widthFix" alt="" class="img">
					<div >
						<svgIcon iconClass="logo" class="logo"/>
						<div class="line26 text-index2" v-if="windowWidth > 820">
							<p>初始品牌店【五润】，2006年于美丽的滨海城市厦门成立，专注于轻食早餐连锁经营，引入全新的生活方式，打造更加舒适的用餐环境，营造时尚简便的用餐体验；目前在厦门岛内外拥有众多门店，五润进行不断的自我迭代与升级，已成为厦门耳熟能详的早餐连锁品牌。</p><br/><br/>
							<p>为了让品牌可高速发展与生态链的无缝协同，五润集团设立了独立的中央厨房、仓储配送分公司及品牌运营中心等核心组织，是一家集产品研发生产、集采贸易、运营管理、信息开发、品牌策划及物流配送为—体的综合性餐饮连锁企业。为了能更好的支撑品牌的快速发展及五润集团生态链板块的完整，分别成立了“五润品牌管理有限公司”“五润科技信息有限公司""厦门九香堂贸易有限公司”与“佐籽( 厦门 )食品有限公司”等十余家旗下品牌来为五润集团旗下品牌进行品牌赋能。</p>
						</div>
					</div>
				</div>
				<div class="fr flex " :class="init?'init':''">
					<img src="@/style/img/intr_bg.png">
				</div>
				<div class="line" v-if="windowWidth < 820">
					<p>2006年，WEROOM五润创立于富有海上花园城市之称的福建厦门，专注于轻食早餐连锁经营，引入全新的生活方式，打造更加舒适的用餐环境，营造时尚简便的用餐体验，让“包子”这一传承食物文化与生活美学方式碰撞出新的生命活力。目前在厦门岛内外拥有40多家门店，五润进行不断的自我迭代已成为厦门家喻户晓的早餐连锁品牌。</p><br/>
					<p>品牌旗下设有独立中央厨房、仓储配送分公司及品牌运营中心三大核心组织，是一家集产品研发、生产、运营管理为一体的综合性餐饮连锁公司。为了能更好的支撑品牌的快速发展及五润生态链板块的完整，分别成立了“五润品牌管理有限公司”“五润科技信息有限公司”“九香堂贸易有限公司”与“佐籽食品有限公司”等旗下品牌来为五润进行品牌赋能。</p>
					<!-- <p>五润集团不仅仅只是提供优质的中餐服务，五润集团的目标是创建中国社区店长发展平台。</p> -->
				</div>
			</div>
		</div>
		
		<div class="box3">
			<div id="box3" class="w1200 box">
				<div class="tit fs42 relative text-c"><span>集团文化</span></div>
				<div class="flex just-between align-items culture">
					<div v-for="(d,i) in culture">
						<div class="fs24 fw name flex align-items">
							{{d.name}}
							<svgIcon iconClass="w" class="img"/>
						</div>
						<div class="text fs32">
							<div class="names">
								<p>{{d.text}}</p>
								<span v-if="d.text1">.</span>
								<p v-if="d.text2">{{d.text2}}</p>
							</div>
							<p v-if="d.text1">{{d.text1}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="jituanBtn" v-if="windowWidth < 820">
			<span v-for="(d,i) in tabList" @click="sub(i)" :key="i" :class="tabActive == i?'cur':''">{{d.name}}</span>
		</div>
		<div id="box4" class="box4 box relative" v-if="tabActive == 0">
			<img src="@/style/img/ry_lc.png" class="bg" mode="widthFix">
			<div class="w1200" v-if="windowWidth > 820">
				<div class="tit fs36 relative text-c"><span>发展历程</span></div>
			</div>
			<div class=" ov">
				<div class="swiper-container backgroundfff">
					<div class="swiper-wrapper course">
							<div v-for="(d,i) in courseList" :key="i" class="swiper-slide" :class="i%2 !== 0?'cur':''">
								<div class="fs30 time cor-8f fw">{{d.time}}</div>
								<div>
									<div v-for="(c,x) in d.child">
										<p class="text cor-f" v-for="(e,s) in c.text">{{e}}</p>
										<div class="text cor-8f fs12">{{c.time1}}</div>
									</div>
								</div>
							</div>
					</div>
				</div>
			</div>
		</div>
		<div id="box5" class="box5 box relative" v-if="windowWidth > 820 && tabActive == 0 || tabActive == 1">
			<div class="w1200" v-if="windowWidth > 820">
				<div class="tit fs36 relative text-c"><span>荣誉资质</span></div>
			</div>

			<div class="data">
				<div class="cont">
					<div v-for="(d,i) in yearsData" :key="i" class="relative" :class="d.name?'cur':''">
						<div class="top" :style="{top:-d.h+-24+'px'}">
							<div v-html="d.name" class="text"></div>
							<div class="h" :style="{height:d.h+'px'}"></div>
						</div>
						<div class="tow">
							<div class="line" :class="d.name?'cur':''">
								<span v-for="(c,i) in 10"></span>
							</div>
							<p>{{d.year}}</p>
						</div>
					</div>
				</div>
				<!-- <img src="@/style/img/fr.png" alt="" srcset=""> -->
				<!-- <div class="more" v-if="windowWidth < 820">右划显示更多<svgIcon iconClass="more" class="img"/></div> -->
			</div>
		</div>
		<div class="scrollBox" v-if="windowWidth > 820">
			<list-scroll class="box" :speed="1" :num="testimonials.length">
				<div class="list">
					<img :src="item" v-for="(item,i) in testimonials" :key="i"/>
				</div>
			</list-scroll>
		</div>
		<rightTab v-if="windowWidth > 820"/>
	</div>
</template>

<script>
	require('../../style/css_w/introduce.css');
	import rightTab from "@/components/rightTab.vue"
	import ListScroll  from "@/components/scroll.vue"
	import Swiper, {Navigation, Pagination}  from 'swiper';
	Swiper.use([Navigation, Pagination]);
	// import { swiper, swiperSlide } from "vue-awesome-swiper";
	export default {
		name: 'Introduce',
		components: {
			rightTab,
			ListScroll
		},
		
		data() {
			return {
				windowWidth: document.body.clientWidth,
				tabIdx: 0,
				init: false,
				timeIdx: 0,
				active: 0,
				yIdx:0,
				tabActive:0,
				tabList:[{
					name:'发展历程'
				},{
					name:'荣誉资质'
				}],
				years:['2006','2007','2008','2009','2010','2011','2012','2012','2013','2014','2015','2016','2017','2018','2019','2020','2021','2022','2023','2024','2025'],
				courseList: [{
					time: '2006',
					child:[{
						text: ['第一家自营门店诞生','代表了“五润”中式早餐连锁的诞生'],
						time1: '2006.04',
					}]
				}, {
					time: '2008',
					child:[{
						text: ['第二家自营门店诞生'],
						time1: '2008.04'
					},
					{
						text: ['五润（厦门）餐饮管理有限公司正式成立','独立中央厨房及配送系统建立'],
						time1: '2008.08'
					},
					{
						text: ['第一家五润特许加盟店开业'],
						time1: '2008.12'
					}]
				},{
					time: '2009',
					child:[{
						text: ['五润品牌店以“五润WeRoom”名称形式','作为中式早餐连锁店推出'],
						time1: '2009.06',
					}]
				}, {
					time: '2012',
					child:[{
						text: ['总部及中央工厂','搬迁至厦门五缘湾商业街'],
						time1: '2012.03',
					}]
				}, {
					time: '2013',
					child:[{
						text: ['第50家门店开业'],
						time1: '2013.03',
					},
					{
						text: ['五润品牌迭代','第六代门店开业'],
						time1: '2013.05',
					}]
				}, {
					time: '2016',
					child:[{
						text: ['五润品牌迭代','第七代门店开业'],
						time1: '2016.09',
					}]
				}, {
					time: '2019',
					child:[{
						text: ['中央工厂入驻','厦门同安湖里工业园区'],
						time1: '2019.03',
					}]
				}, {
					time: '2020',
					child:[{
						text: ['厦门五润信息科技有限公司成立'],
						time1: '2020.04',
					},{
						text: ['五润品牌迭代','第八代门店开业'],
						time1: '2020.10',
					}]
				},  {
					time: '2021',
					child:[{
						text: ['荣获“厦门市早餐工程”承办单位'],
						time1: '2021.07',
					}]
				}, {
					time: '2022',
					child:[{
						text: ['五润总部营运中心','搬迁至天地金融港'],
						time1: '2022.03',
					},{
						text: ['品牌VI升级'],
						time1: '2022.11',
					}]
				}],
				tab: [{
					name: '集团简介',
					id: '300'
				}, {
					name: '企业文化',
					id: '900'
				}, {
					name: '发展历程',
					id: '1500'
				}, {
					name: '荣誉资质',
					id: '2300'
				}],
				culture: [ {
					name: '我们的愿景',
					text: '有社区， 就有五润',
					url: 'wh2'
				}, {
					name: '我们的使命',
					text: '致力于打造更有',
					text2: '品质的社区生活平台',
					url: 'wh3'
				}, {
					name: '我们的核心价值观',
					text: '简单、快乐、成功',
					url: 'wh4'
				}, {
					name: '我们的Slogan',
					text: '五润',
					text1: '只为更好生活',
					url: 'wh1'
				}],
				yearsData: [{
					year:'',
					h:'0',
					name:''
				},{
					year:'2006',
					h:'0',
					name:''
				},{
					year:'2007',
					h:'0',
					name:''
				},{
					year:'2008',
					h:'0',
					name:''
				},{
					year:'2009',
					h:'40',
					name:'<div><p>诚信商家</p></div>'
				},{
					year:'2010',
					h:'80',
					name:'<div><p>诚信商家</p></div>'
				},{
					year:'2011',
					h:'120',
					name:'<div><p>厦门市优秀连锁企业</p></div>'
				},{
					year:'2012',
					h:'0',
					name:''
				},{
					year:'2013',
					h:'0',
					name:''
				},{
					year:'2014',
					h:'20',
					name:'<div><p>中国十大包子名店</p><p>中国十佳早餐</p><p>中国十佳餐饮连锁品牌</p><p>五润大包”荣获第十五届中国美食节金鼎奖</p><p>荣登“中国美食星势力榜</p><p>厦门文明餐桌示范点</p><p>9款面点获“中国名点”证书</p><p>(上海生煎包、带骨排骨包、蛋黄流沙包、酱烧猪排包、蜜汁叉烧包、五丁果蔬宝、五润鲜肉包、椰丝卷、五润鲜肉粽)</p><p>"五润大包"中国特色包子</p><p>海西十佳连锁餐饮品牌</p><p>全国公开水域游泳(厦门.五缘湾)邀请赛 指定餐饮供应单位</p><p>获得福建省烹饪技能竞赛金奖/银奖</p><p>第十届中国俱乐部杯帆船挑战赛 指定餐饮供应单位</p></div>'
				},{
					year:'2015',
					h:'200',
					name:'<div><p>中国粮油学会第三届优秀单位会员</p><p>全国风筝精英赛(厦门站)暨厦门国际风筝节指定餐饮供应单位</p><p>厦门市成长型中小微企业</p><p>第十一届中国俱乐部杯帆船挑战赛指定餐饮供应单位</p></div>'
				},{
					year:'2016',
					h:'120',
					name:'<div><p>厦门市成长型中小微企业</p><p>福建省优秀餐饮企业</p><p>第十二届中国俱乐部杯帆船挑战赛指定餐饮供应单位</p></div>'
				},{
					year:'2017',
					h:'80',
					name:'<div><p>福建省餐饮业十大休闲简餐品牌</p></div>'
				},{
					year:'2018',
					h:'0',
					name:''
				},{
					year:'2019',
					h:'0',
					name:''
				},{
					year:'2020',
					h:'60',
					name:'<div><p>优秀连锁会员企业</p><p>厦门市“疫情抗疫”首批 特许集体用餐配送单位</p></div>'
				},{
					year:'2021',
					h:'100',
					name:'<div><p>荣获“厦门市早餐工程”承办单位</p></div>'
				},{
					year:'2022',
					h:'0',
					name:''
				},{
					year:'2023',
					h:'0',
					name:''
				},{
					year:'2024',
					h:'0',
					name:''
				},{
					year:'2025',
					h:'0',
					name:''
				}],
				testimonials:[
					'https://qiniuimg.wurun.net/php/1.png',
					'https://qiniuimg.wurun.net/php/2.png',
					'https://qiniuimg.wurun.net/php/3.jpg',
					'https://qiniuimg.wurun.net/php/4.jpg',
					'https://qiniuimg.wurun.net/php/5.jpg',
					'https://qiniuimg.wurun.net/php/6.jpg',
					'https://qiniuimg.wurun.net/php/7.jpg',
					'https://qiniuimg.wurun.net/php/8.jpg',
					'https://qiniuimg.wurun.net/php/9.png',
					'https://qiniuimg.wurun.net/php/10.png',
					'https://qiniuimg.wurun.net/php/11.jpg',
					'https://qiniuimg.wurun.net/php/12.jpg',
					'https://qiniuimg.wurun.net/php/13.jpg',
					'https://qiniuimg.wurun.net/php/14.jpg',
					'https://qiniuimg.wurun.net/php/15.jpg',
					'https://qiniuimg.wurun.net/php/16.jpg',
					'https://qiniuimg.wurun.net/php/17.jpg',
					'https://qiniuimg.wurun.net/php/18.jpg',
					'https://qiniuimg.wurun.net/php/19.jpg',
					'https://qiniuimg.wurun.net/php/20.jpg',
					'https://qiniuimg.wurun.net/php/21.jpg',
					'https://qiniuimg.wurun.net/php/22.jpg',
					'https://qiniuimg.wurun.net/php/23.jpg',
					'https://qiniuimg.wurun.net/php/24.jpg',
					'https://qiniuimg.wurun.net/php/25.jpg',
					'https://qiniuimg.wurun.net/php/26.jpg',
					'https://qiniuimg.wurun.net/php/27.jpg',
					'https://qiniuimg.wurun.net/php/28.jpg',
					'https://qiniuimg.wurun.net/php/29.jpg',
					'https://qiniuimg.wurun.net/php/30.jpg',
					'https://qiniuimg.wurun.net/php/31.jpg',
					'https://qiniuimg.wurun.net/php/32.jpg',
					'https://qiniuimg.wurun.net/php/33.jpg',
					'https://qiniuimg.wurun.net/php/34.jpg',
					'https://qiniuimg.wurun.net/php/35.jpg',
					'https://qiniuimg.wurun.net/php/36.jpg',
					'https://qiniuimg.wurun.net/php/37.jpg',
					'https://qiniuimg.wurun.net/php/38.jpg',
					'https://qiniuimg.wurun.net/php/39.jpg',
				],
				yearsDatas: [{
					years: '2019',
					yearsList: [{
						name: '诚信商家'
					}],
					imgArr: ['https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2009-2010.jpg'
					]
				},{
					years: '2010',
					yearsList: [{
						name: '诚信商家'
					}],
					imgArr: ['https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2009-2010.jpg'
					]
				}, {
					years: '2011',
					yearsList: [{
						name: '厦门市优秀连锁企业'
					}],
					imgArr: ['https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2011_01.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2012_01.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2013_01.jpg'
					]
				}, {
					years: '2014',
					yearsList: [{
						name: '中国十大包子名店'
					},
					{
						name: '中国十佳早餐'
					},
					{
						name: '中国十佳餐饮连锁品牌'
					},
					{
						name: '“五润大包” 荣获第十五届中国美食节金鼎奖'
					},
					{
						name: '荣登“中国美食星势力榜”'
					},
					{
						name: '厦门文明餐桌示范点'
					},
					{
						name: '9款面点获“中国名点”证书（上海生煎包、带排骨包、蛋黄流沙包、酱烧猪排包、蜜汁叉烧包、五丁果蔬包、五润鲜肉包、椰丝卷、五润鲜肉粽）'
					},
					{
						name: '“五润大包”中国特色包子'
					}],
					imgArr: ['https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_01.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_05.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_06.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E5%8F%89%E7%83%A7%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E9%AB%98%E4%B8%BD%E8%8F%9C%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E6%9E%9C%E8%94%AC%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E6%B5%81%E6%B2%99%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E5%A5%B6%E9%BB%84%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E6%8E%92%E9%AA%A8%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E7%B4%A0%E4%B8%89%E9%B2%9C%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E4%BA%94%E6%B6%A6%E5%A4%A7%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E4%BA%94%E6%B6%A6%E7%85%8E%E9%A5%BA.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E4%BA%94%E6%B6%A6%E7%83%A7%E9%BA%A6.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E4%BA%94%E6%B6%A6%E7%94%9F%E7%85%8E%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E4%BA%94%E6%B6%A6%E7%B4%A0%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E4%BA%94%E6%B6%A6%E9%B2%9C%E8%82%89%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E4%BA%94%E6%B6%A6%E9%B2%9C%E8%82%89%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E4%BA%94%E6%B6%A6%E9%B2%9C%E8%82%89%E7%B2%BD.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E7%9B%B8%E6%80%9D%E7%BA%A2%E8%B1%86%E5%8C%85.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E6%A4%B0%E4%B8%9D%E5%8D%B7.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E6%A4%B0%E4%B8%9D%E5%8D%B7.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2014_%E7%8C%AA%E6%8E%92%E5%8C%85.jpg'
					]
				}, {
					years: '2015',
					yearsList: [{
						name: '海西十佳连锁餐饮品牌'
					}, {
						name: '全国公开水域游泳（厦门五缘湾）邀请赛指定餐饮供应单位'
					}, {
						name: '获得福建省烹饪技能竞赛金奖/银奖'
					}, {
						name: '第十届中国俱乐部杯帆船挑战赛指定餐饮供应单位'
					},{
						name: '中国粮油学会第三届优秀单位会员'
					}, {
						name: '全国风筝精英赛（厦门站)暨厦门国际风筝节指定餐饮供应单位'
					}, {
						name: '第十一届中国俱乐部杯帆船挑战赛指定餐饮供应单位'
					}, {
						name: '2015-2016厦门市成长型中小微企业'
					}],
					imgArr: ['https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2015_01.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2015_01.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2015-2016.jpg'
					]
				}, {
					years: '2016',
					yearsList: [{
						name: '福建省优秀餐饮企业'
					}, {
						name: '第十二届中国俱乐部杯帆船挑战赛指定餐饮供应单位'
					}, {
						name: '福建餐饮业十大休闲简餐品牌'
					}],
					imgArr: ['https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2016_01.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2016_02.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2016_03.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2016_04.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2016_05.jpg'
					]
				}, {
					years: '2020',
					yearsList: [{
						name: '年度优秀连锁会员企业'
					}, {
						name: '厦门市“疫情抗疫”首批特许集体用餐配送单位'
					}],
					imgArr: ['https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/2020_01.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/%E9%87%91%E5%A5%96.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/%E9%93%B6%E5%A5%96.jpg'
					]
				},
				 {
					years: '2021',
					yearsList: [{
						name: '荣获“厦门市早餐工程”承办单位'
					}],
					imgArr: ['https://qiniuimg.wurun.net/wurun_pc%2Fzs.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/%E9%87%91%E5%A5%96.jpg',
						'https://qiniuimg.wurun.net/%E8%8D%A3%E8%AA%89%E8%B5%84%E8%B4%A8/%E9%93%B6%E5%A5%96.jpg'
					]
				}
				],
				honor: {}
			}
		},
		computed: {
			
		},
		mounted() {
			this.windowWidth  = document.body.clientWidth
			document.documentElement.scrollTop = 0
			window.addEventListener('resize', () => this.windowWidth = window.innerWidth, false)
			this.honor = this.yearsData[0]
			setTimeout(() => {
				this.init = true
			}, 500)
			this.time()
		},
		watch: {
			windowWidth: {
				handler(e) {
					console.log(this.windowWidth,111);
				},
				deep: true
			}
		},
		methods: {
			sub(i){
				this.tabActive = i
			},
			subYears(i){
				this.yIdx = i
			},
			time() {
				let t = 0
				let time = setInterval(() => {
					if (t < this.yearsData.length+1) {
						t++
						this.active = t
					} else {
						t = -1
					}
				}, 2000)
			},
			look(d,i) {
				// this.honor = d
				// this.tabIdx = i
			},
			goToDem(i, d) {
				this.tabIdx = i
				let timer = setInterval(res => {
					let osTop = document.documentElement.scrollTop || document.body.scrollTop;
					let ispeed = Math.floor(d.id / 5);
					document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
					if (osTop >= d.id) {
						clearInterval(timer);
					}
				}, 40);
			}
		}
	}
</script>

<style scoped>
	@import url("/node_modules/swiper/css/swiper.css");

</style>
